import {cn} from '@/lib/utils';
import {StrapiMenuItem} from '@/types/strapi';
import {useLocale} from 'next-intl';
import {ReactNode} from 'react';
import NavigationSubMenu from '../NavigationSubMenu';

type Props = {
  children?: ReactNode;
  sideMenu?: {title?: string; content?: StrapiMenuItem[]};
};
export default function FullWidthTemplate({children, sideMenu = {}}: Props) {
  const lang = useLocale();
  return (
    <div className={cn('md:flex ')}>
      {(sideMenu?.content || []).length > 0 && (
        <div className="w-full md:w-[30%] overflow-x-hidden mt-[20px]">
          <NavigationSubMenu
            lang={lang}
            menu={sideMenu?.content || []}
            title={sideMenu?.title}
          />
        </div>
      )}

      <div
        className={cn(
          'relative flex grow flex-col w-full',
          (sideMenu?.content || []).length > 0 && 'md:w-[70%]'
        )}
      >
        <div className="md:text-[18px] min-h-[calc(100vh-600px)] relative">
          {children}
        </div>
      </div>
    </div>
  );
}
